import { APIHelpers } from '@/api/apiHelpers';

const IDENTITY_API_PROD = 'https://identity.api.manifoldxyz.dev';

export const identityBaseUrl =
  import.meta.env.DEV && import.meta.env.VITE_APP_IDENTITY_API_URL
    ? import.meta.env.VITE_APP_IDENTITY_API_URL
    : IDENTITY_API_PROD;

class IdentityApi extends APIHelpers {
  constructor() {
    super();
    this.baseUrl = identityBaseUrl;
  }

  /**
   * Get Twitter handle for a workspace
   */
  async getTwitterHandle(workspaceId: string): Promise<string | null> {
    try {
      const userData = await this.fetchWithTimeout(`/workspace-badges?workspaceId=${workspaceId}`);
      return userData.socials?.twitter || null;
    } catch {
      return null;
    }
  }

  async getUserData(address: string): Promise<Response | null> {
    try {
      const userData = await this.fetchWithTimeout(`/badges?walletAddress=${address}`, {
        method: 'GET',
      });
      return userData;
    } catch {
      return null;
    }
  }
}

export const identityApi = new IdentityApi();
